import Typeahead from './Typeahead.connect';

export default Typeahead;
